import Css from './Css.js';
import closeImg from '../Images/pop_guide_close.png';
import Api from '../Api/Api.js';
import { useEffect, useState } from 'react';
import QRcode from "qrcode";
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function QrCode(props){
  const {t} = useTranslation();
  const {qrCodeData,editorWidth} = props.data;
  const {closeQrCode} = props.method;
  const type = qrCodeData.type; //1客户二维码  2创作者二维码
  const videoId = qrCodeData.videoId;
  const uid = qrCodeData.uid;
  const pf = qrCodeData.pf;
  let [qrcodeUrl, setQrcodeUrl] = useState('');

  useEffect(()=>{
    let param = JSON.stringify({
      videoId: videoId,
      uid: uid,
      pf: pf,
      type: type,
    });
    axios.post(Api.getQrCode, param).then(function (response) {
      const res = response.data;
      if(res && res.code === 0){
        QRcode.toDataURL(res.data.qrCode, {
          type: "image/png", //类型
          quality: 0.5, //图片质量A Number between 0 and 1
          width: 140,   //高度
          height: 140,  //宽度
          errorCorrectionLevel: "L", //容错率
          margin: 2,   //外边距
          color: {
            dark: "#000", //前景色
            light: "#fff" //背景色
          }
        }).then(imgData => {
          setQrcodeUrl(imgData);
        })
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  },[videoId,uid,pf,type])

  return (
    <>
      {
        pf === 'Audiodesires_demo' ?
        <div className="qrCodeWrap" style={ Css.qrCodeDiv(qrCodeData.w, qrCodeData.h,pf) }>
          <div style={ Css.codeArea1(editorWidth, pf) }>
            <div style={ Css.codeArea1(editorWidth, pf).txtArea }>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("exomoon.audiodesires.text2")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("exomoon.audiodesires.text3")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("exomoon.audiodesires.text4")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("exomoon.audiodesires.text5")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("exomoon.audiodesires.text6")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("exomoon.audiodesires.text7")}</div>
            {/* <div style={ Css.codeArea1(editorWidth, pf).dno } dangerouslySetInnerHTML={{__html:"<a style='color:#ffffff;cursor:pointer'; href='https://zh.lovense.com/public/store' target='_blank' rel='noreferrer'>Click here</a>"}} ></div> */}
            <div style={ Css.codeArea1(editorWidth, pf).dno } dangerouslySetInnerHTML={{__html:t("exomoon.audiodesires.text8")}} ></div>
            {/* <a style={Css.codeArea1(editorWidth, pf).here} href="https://zh.lovense.com/public/store" target="_blank" rel="noreferrer">{t("clickHere")}</a> {t("findOne")} */}
            </div>
            <div style={ Css.codeArea1(editorWidth, pf).rightArea }>
              <div style={ Css.codeArea1(editorWidth, pf).codeImg }>
                <img src={qrcodeUrl} alt=""/>
              </div>
            </div>
            <div style={ Css.codeArea1(editorWidth, pf).closeBtn }>
              <img onClick={ closeQrCode } style={ Css.codeArea1(editorWidth, pf).closeImg } src={ closeImg } alt=""/>
            </div>
          </div>
        </div> : ""
      }
      {
        type === 2&&pf !== 'Audiodesires_demo' ?
        <div style={ Css.qrCodeDiv(qrCodeData.w, qrCodeData.h) }>
          <div style={ Css.codeArea1(editorWidth, pf) }>
            <div style={ Css.codeArea1(editorWidth, pf).txtArea }>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("previewTip2")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("previewTip3")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("previewTip4")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("previewTip5")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title }>{t("previewTip6")}</div>
              <div style={ Css.codeArea1(editorWidth, pf).title2 }>{t("previewTip7")}</div>
            <div style={ Css.codeArea1(editorWidth, pf).dno }>{t("notHaveToy")} <a style={Css.codeArea1(editorWidth, pf).here} href="https://zh.lovense.com/public/store" target="_blank" rel="noreferrer">{t("clickHere")}</a> {t("findOne")}</div>
            </div>
            <div style={ Css.codeArea1(editorWidth, pf).rightArea }>
              <div style={ Css.codeArea1(editorWidth, pf).codeImg }>
                <img src={qrcodeUrl} alt=""/>
              </div>
              <div style={ Css.codeArea1(editorWidth, pf).codeTxt }>{t("QR Code")}</div>
            </div>
            <div style={ Css.codeArea1(editorWidth, pf).closeBtn }>
              <img onClick={ closeQrCode } style={ Css.codeArea1(editorWidth, pf).closeImg } src={ closeImg } alt=""/>
            </div>
          </div>
        </div> : ""
      }
      {
        type === 1&&pf !== 'Audiodesires_demo' ? 
        <div style={ Css.qrCodeDiv2(qrCodeData.w, qrCodeData.h) }>
          <div style={ Css.div2Layer(qrCodeData.w, qrCodeData.h) }></div>
          <div style={ Css.codeArea2(editorWidth, pf) }>
          <div style={ Css.codeArea2(editorWidth, pf).txtArea }>
              <div style={ Css.codeArea2(editorWidth, pf).redTitle }>{t("previewTip1")}</div>
              <div style={ Css.codeArea2(editorWidth, pf).title }>
                {t("previewTip2")}
                <span style={ Css.codeArea2(editorWidth, pf).span }>
                {t("previewTip3")}
                </span>
              </div>
              <div style={ Css.codeArea2(editorWidth, pf).title }>
                {t("previewTip4")}
                <span style={ Css.codeArea2(editorWidth, pf).span }>
                {t("previewTip5")}
                </span>
              </div>
              <div style={ Css.codeArea2(editorWidth, pf).title }>
                {t("previewTip6")}
                <span style={ Css.codeArea2(editorWidth, pf).span }>
                {t("previewTip7")}
                </span>
              </div>
            </div>
            <div style={ Css.codeArea2(editorWidth, pf).rightArea }>
              <div style={ Css.codeArea2(editorWidth, pf).codeImg }>
                <img src={qrcodeUrl} alt=""/>
              </div>
            </div>
            <div style={ Css.codeArea2(editorWidth, pf).closeBtn }>
              <img onClick={ closeQrCode } style={ Css.codeArea2(editorWidth, pf).closeImg } src={ closeImg } alt=""/>
            </div>
          </div>
        </div> : ""
      }
    </>
  );
}

export default QrCode;